<template>
    <div
        v-if="hasErrors"
        class="rounded-lg border-error-600 p-4 border bg-[#fffbfa]"
    >
        <div class="font-medium text-error-600">
            Whoops! Something went wrong.
        </div>

        <ul class="mt-3 text-sm text-error-600 list-inside">
            <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    computed: {
        errors() {
            return this.$page.props.errors;
        },

        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
    },
};
</script>
